import { PlayerError } from '@foundation-player/error-codes';
import { AdvertisingEvent } from '../../advertising/event-types';
import { PlayerEvent } from '../../event-emitter/events';
import { FoundationErrorEvent } from '../../event-emitter/unfiltered';
import { PlayerInterface } from '../../player-interface';

export enum DestroyReason {
  HOMAD = 'HOMAD',
}

/**
 * This classes listens on certain player events to determine if a fatal error occurred.
 * If a fatal error occurred, it will emit a new event and destroy the player if possible.
 */
export class ErrorObserver {
  constructor(private readonly player: PlayerInterface) {
    player.addEventListener(PlayerEvent.Error, (event: FoundationErrorEvent) => this.onError(event));
    player.addEventListener(AdvertisingEvent.HomadPenalty, (event: FoundationErrorEvent) => this.onHomadPenalty(event));
  }

  async onError(errorEvent: FoundationErrorEvent) {
    await this.handleError(errorEvent);
  }

  onHomadPenalty(errorEvent: FoundationErrorEvent) {
    this.handleHomadPenalty(errorEvent);
  }

  private handleHomadPenalty(errorEvent: FoundationErrorEvent) {
    const event = new FoundationErrorEvent(PlayerEvent.Error, {
      code: PlayerError.ADBLOCKER_DETECTED_34100.code,
      name: DestroyReason.HOMAD,
      originalEvent: errorEvent,
    });
    this.player.dispatchEvent(event);
  }

  private async handleError(errorEvent: FoundationErrorEvent) {
    const isAdBlockerError = errorEvent.code === PlayerError.ADBLOCKER_DETECTED_34100.code;
    const isDrmError =
      errorEvent.code &&
      errorEvent.code >= PlayerError.FALLBACK_DRM_ERROR_10000.code &&
      errorEvent.code < PlayerError.CONTENT_20000.code;
    const isContentError =
      errorEvent.code &&
      errorEvent.code >= PlayerError.CONTENT_20000.code &&
      errorEvent.code < PlayerError.CLIENT_30000.code;

    if (isAdBlockerError || isDrmError || isContentError) {
      await this.player.destroy(errorEvent);
    }
  }
}
